import React from 'react';
import { Modal } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { isInvestor, isPaymentRequest } from 'utils';
import { ReactComponent as WarningBlue } from 'assets/icons/warning-blue.svg';
//import { ReactComponent as WarningPurple } from 'assets/icons/warning-purple.svg';
import { ReactComponent as WarningRed } from 'assets/icons/warning-red.svg';
import { outcomes } from 'utils';

const CustomModal = ({
  isVisible,
  title,
  handleConfirm,
  handleCancel,
  children,
  submitDisabled,
  formKey,
  Icon,
  outcome,
  ...rest
}) => {
  const user = useSelector(state => state.user);
  const investor = isInvestor(user.privileges);
  const renderIcon = () => {
    if (investor) {
      return <WarningBlue />;
    } 
    // else if (isBankFinalReview) {
    //   return <WarningRed />;
    // } else {
    //   return <WarningPurple />;
    // }
  };

  return (
    <Modal
      open={isVisible}
      onOk={handleConfirm}
      onCancel={handleCancel}
      centered
      className={`custom-modal`}
      okButtonProps={{
        disabled: submitDisabled,
        id: 'custom-modal__ok-button',
        className: 'custom-modal__ok-button'
      }}
      cancelButtonProps={{
        id: 'custom-modal__cancel-button',
        className: 'custom-modal__cancel-button',
      }}
      {...rest}
    >
      <div className="custom-modal-header" style={{display:"flex"}}>
        {/* {Icon ? <Icon /> : renderIcon()} */}
        <span>{title}</span>
      </div>
      <div className="custom-modal-body">{children}</div>
    </Modal>
  );
};

export default CustomModal;
